/**
 * Segment-landingspagina's: de portie-switcher, de kaartselectie en de tekst in
 * de sticky balk.
 *
 * Wat hier BEWUST niet in zit:
 *
 * - De add-to-cart. `sm-cart-drawer.liquid` luistert al op elk formulier met een
 *   `/cart/add`-action en regelt daar de AJAX-route, de wachtrij, de
 *   dubbelklik-bescherming en de terugval bij een 422. Een tweede implementatie
 *   zou daarvan afdrijven.
 * - Het verschijnen en verdwijnen van de sticky balk zelf. Dat doet `sm-lp.js`
 *   al met een IntersectionObserver op `#bestellen`. Hier wordt alleen de tekst
 *   en de link bijgewerkt, zodat de balk de gekozen kaart volgt.
 * - Prijs- en voorraadlogica. Alle drie de porties staan al server-side
 *   gerenderd; wisselen is een `hidden` omzetten, geen herberekening.
 *
 * Zonder dit script blijft de pagina werken: de standaardportie staat zichtbaar,
 * de andere twee op `hidden`, en elk formulier post native.
 */
(() => {
  const blok = document.querySelector('[data-lpseg-pakket]');
  if (!blok) return;

  const knoppen = [...blok.querySelectorAll('[data-lpseg-portie]')];
  const kaarten = [...blok.querySelectorAll('[data-lpseg-kaart]')];
  const status = blok.querySelector('[data-lpseg-status]');
  const sticky = document.querySelector('[data-lp-sticky]');
  const stickyNoot = sticky?.querySelector('.lp-sticky__note');
  const stickyKnop = sticky?.querySelector('a, button');
  // Het label uit de sectie-instelling (`cta_label`), vastgehouden vóór een kaart het overschrijft.
  const stickyLabel = stickyKnop?.textContent.trim() || 'Bekijk de pakketten';

  /** Alleen de porties die niet op álle kaarten uitverkocht zijn. */
  const kiesbaar = () => knoppen.filter((k) => !k.disabled);

  let portie = blok.dataset.standaardPortie || '350';
  let kaartIndex = Math.max(0, kaarten.findIndex((k) => k.hasAttribute('data-lpseg-standaard-kaart')));

  /** De zichtbare portie-tak van een kaart, of null als die kaart hem niet heeft. */
  const tak = (kaart, maat) => kaart.querySelector(`[data-lpseg-kaart-portie="${maat}"]`);

  /**
   * De sticky balk volgt de geselecteerde kaart: dezelfde prijs, dezelfde
   * knoptekst en dezelfde bestemming. Staat er geen balk op de pagina, dan doet
   * dit niets — de balk is een losse sectie en hoeft er niet te zijn.
   */
  function stickyBij() {
    if (!sticky || !stickyKnop) return;
    const kaart = kaarten[kaartIndex];
    const t = kaart && tak(kaart, portie);
    if (!t) return;

    const bedrag = t.querySelector('.lpseg-kaart__bedrag')?.textContent.trim();
    const kop = kaart.querySelector('.lpseg-kaart__kop')?.textContent.trim();
    if (stickyNoot && bedrag && kop) stickyNoot.textContent = `${kop} · ${bedrag}`;

    const link = t.querySelector('a.btn');
    const knop = t.querySelector('button[type="submit"]');
    const uit = t.querySelector('button[disabled]');

    if (uit) {
      // Nooit een dode knop in de balk. Is de gekozen kaart op, dan wijst de balk
      // naar het aanbodblok en kan de klant daar een andere kaart pakken.
      stickyKnop.textContent = 'Bekijk de pakketten';
      if ('href' in stickyKnop) stickyKnop.href = `#${blok.id}`;
    } else if (link) {
      stickyKnop.textContent = link.textContent.trim();
      if ('href' in stickyKnop) stickyKnop.href = link.getAttribute('href');
    } else if (knop) {
      // Kaart 2 en 3 zitten in een formulier. De balk is een link, dus hij stuurt
      // naar het blok in plaats van zelf toe te voegen: toevoegen buiten beeld,
      // zonder dat de klant ziet wát hij toevoegt, is precies de klik die je
      // daarna in de wagen weer kwijtraakt. Daarom NIET de knoptekst van de kaart
      // overnemen ("In de winkelwagen" op een link die alleen scrolt — evaluator
      // 21-09 op lp-gezin), maar het label dat de balk zelf meekreeg.
      stickyKnop.textContent = stickyLabel;
      if ('href' in stickyKnop) stickyKnop.href = `#${blok.id}`;
    }
  }

  /** Wissel de zichtbare portie op alle kaarten tegelijk. */
  function zetPortie(maat, meld = true) {
    portie = maat;
    kaarten.forEach((kaart) => {
      kaart.querySelectorAll('[data-lpseg-kaart-portie]').forEach((t) => {
        t.hidden = t.dataset.lpsegKaartPortie !== maat;
      });
    });
    knoppen.forEach((k) => {
      const aan = k.dataset.lpsegPortie === maat;
      k.setAttribute('aria-checked', String(aan));
      k.tabIndex = aan ? 0 : -1;
    });

    // Is de gekozen kaart in déze portie uitverkocht, kies dan de dichtstbijzijnde
    // die wél leverbaar is (§6). Zo staat er nooit een dode knop geselecteerd.
    if (!leverbaar(kaartIndex, maat)) {
      const vervanger = dichtstbijzijnde(kaartIndex, maat);
      if (vervanger !== -1) zetKaart(vervanger, false);
    }

    if (meld && status) status.textContent = `Portie ${maat} gram geselecteerd.`;
    stickyBij();
  }

  const leverbaar = (i, maat) => {
    const t = kaarten[i] && tak(kaarten[i], maat);
    return Boolean(t) && !t.querySelector('button[disabled]');
  };

  /** Index van de leverbare kaart die het dichtst bij `vanaf` ligt, of -1. */
  function dichtstbijzijnde(vanaf, maat) {
    for (let afstand = 1; afstand < kaarten.length; afstand += 1) {
      for (const i of [vanaf - afstand, vanaf + afstand]) {
        if (i >= 0 && i < kaarten.length && leverbaar(i, maat)) return i;
      }
    }
    return -1;
  }

  function zetKaart(i, meld = true) {
    kaartIndex = i;
    kaarten.forEach((k, n) => k.classList.toggle('is-gekozen', n === i));
    if (meld && status) {
      const kop = kaarten[i]?.querySelector('.lpseg-kaart__kop')?.textContent.trim();
      if (kop) status.textContent = `${kop} geselecteerd.`;
    }
    stickyBij();
  }

  knoppen.forEach((knop) => {
    knop.addEventListener('click', () => {
      if (!knop.disabled) zetPortie(knop.dataset.lpsegPortie);
    });

    // Radiogroep-gedrag: pijltjes wisselen binnen de groep en slaan uitverkochte
    // opties over, Tab verlaat de groep in één keer.
    knop.addEventListener('keydown', (e) => {
      const stap = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!stap) return;
      e.preventDefault();
      const rij = kiesbaar();
      if (rij.length === 0) return;
      const nu = rij.indexOf(knop);
      const volgende = rij[(nu + stap + rij.length) % rij.length];
      volgende.focus();
      zetPortie(volgende.dataset.lpsegPortie);
    });
  });

  kaarten.forEach((kaart, i) => {
    kaart.addEventListener('click', (e) => {
      // Een klik op de knop of de link is een koopactie, geen kaartkeuze — die
      // laat je met rust, anders selecteert de kaart zich net vóór de navigatie
      // en flikkert de rand.
      if (e.target.closest('a, button')) return;
      zetKaart(i);
    });
  });

  /**
   * Bevestiging na een geslaagde add-to-cart.
   *
   * Op de winkelpagina's meldt de cart-drawer een toevoeging met een melding bij
   * het wagenicoon en blijft de la dicht — een bewuste keuze, zie
   * `sm-cart-drawer.liquid`. Op een LP kan dat niet: `sm-lp-header` draagt geen
   * winkelwagen, dus die melding heeft geen plek om te verschijnen en de
   * toevoeging zou volledig onzichtbaar zijn.
   *
   * Daarom opent de la hier wél (Ronald, masterbriefing §6). Dat is de enige
   * bevestiging die deze pagina heeft, en tegelijk de enige weg naar de
   * afrekenknop.
   */
  document.addEventListener('sm:cart:toegevoegd', () => {
    const la = document.querySelector('[data-cart-drawer]');
    if (la && !la.open && typeof la.showModal === 'function') la.showModal();
  });

  // Staat de standaardportie bij het laden al uitverkocht, kies dan de eerste die
  // dat niet is. Dit gebeurt vóór de eerste melding, dus zonder `meld`.
  const startKnop = knoppen.find((k) => k.dataset.lpsegPortie === portie);
  if (startKnop?.disabled) {
    const eerste = kiesbaar()[0];
    if (eerste) zetPortie(eerste.dataset.lpsegPortie, false);
  } else {
    zetPortie(portie, false);
  }
  zetKaart(kaartIndex, false);
})();
